
// today
const minDateNow = () => {
  let isNow = new Date()
  let month = isNow.getMonth() + 1
  let day = isNow.getDate()
  let today = isNow.getFullYear() + '-' + (('' + month).length < 2 ? '0' : '') + month + '-' + day
  return today
}

// 30 days after
const maxDateNow = () => {
  let beforedate = new Date()
  let priordate = new Date()
  priordate.setDate(beforedate.getDate() + 90)
  let dd2 = priordate.getDate()
  let mm2 = priordate.getMonth() + 1
  let yyyy2 = priordate.getFullYear()
  if (dd2 < 10) { dd2 = '0' + dd2 };
  if (mm2 < 10) { mm2 = '0' + mm2 };
  let datefrommonthago = yyyy2 + '-' + mm2 + '-' + dd2

  return datefrommonthago
}

export default () => ({
  force_speciality: true,
  force_professional: false,
  othersAddress: [
    {
      id: 'all',
      label: 'Informe o CEP, Endereço, Cidade'
    },
    {
      id: 'current',
      label: 'Próximo a Minha Localização Atual'
    },
    {
      id: null,
      label: 'Selecione uma opção'
    }
  ],
  agenda: {
    name: null,
    address: {
      street: null,
      number: null,
      district: null,
      city: null,
      zip: null
    },
    price_start: null,
    price_end: null,
    location: {
      id: null,
      distance: 10,
      latitude: null,
      longitude: null
    },
    period: null,
    level_id: 'professional',
    covenant_type: null,
    professional: {
      id: null,
      name: null
    },
    speciality: {
      id: null,
      name: null
    },
    patient: {
      id: null,
      label: null,
      type: null
    },
    date_start: null,
    date_end: null
  },
  covenantTypeOptions: [
    {
      id: true,
      label: 'Somente Credenciados ao seu plano'
    },
    {
      id: null,
      label: 'Credenciados e Particulares'
    }
  ],
  levelOptions: [
    {
      id: 'today', label: 'Hoje'
    },
    {
      id: 'next3days', label: 'Próximos 3 dias'
    },
    {
      id: 'nextweek', label: 'Próximo 7 dias'
    },
    {
      id: 'professional', label: 'Disponibilidade do profissional'
    },
    {
      id: 'others', label: 'Outros (Especificar datas)'
    }
  ],
  periodOptions: [
    {
      id: null, label: 'Informar o período'
    },
    {
      id: 'morning', label: 'Manhã'
    },
    {
      id: 'afternoon', label: 'Tarde'
    },
    {
      id: 'nigth', label: 'Noite'
    }
  ],
  date: new Date(),
  config: {
    minDate: minDateNow(),
    maxDate: maxDateNow(),
    sideBySide: true,
    useCurrent: false,
    locale: 'pt-br',
    format: 'DD/MM/YYYY',
    widgetPositioning: {
      horizontal: 'left',
      vertical: 'bottom'
    }
  },
  professionalSpecialityOptions: [],
  specialityOptions: [],
  hiddenOptions: false
})



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/advanced/resources/data.js